import { useLocation, useNavigate } from "react-router-dom";

import StyledMenu from "./style";

const MenuSidebar = ({ items = [], userEmail }) => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <StyledMenu
      selectedKeys={[location.pathname]}
      items={items?.map(({ disabled, path, label, Icon }) => ({
        disabled,
        key: path,
        label: (
          <>
            <div className="container-sidebar-icon">
              <Icon />
            </div>
            {label}
          </>
        ),
        onClick: () =>
          navigate(`${path}?email=${encodeURIComponent(userEmail)}`),
      }))}
    />
  );
};

export default MenuSidebar;
